var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user.objectId
    ? _c(
        "section",
        {
          staticClass: "full-center loading",
          class: {
            "loading-active": _vm.isProgressActive,
            "loading-init-complete": _vm.isAppReady,
            transparent: _vm.isTransparent,
          },
        },
        [
          _vm.property.objectId || _vm.currentBuilding.objectId
            ? _c(
                "h1",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.isProgressActive &&
                        !_vm.isAppReady &&
                        !_vm.isLoadingBarCustom,
                      expression:
                        "isProgressActive && !isAppReady && !isLoadingBarCustom",
                    },
                  ],
                  staticClass: "progress-preview-title",
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(
                        _vm.property.name ||
                          _vm.currentBuilding.nameMulti[_vm.lang] ||
                          _vm.currentBuilding.name
                      ) +
                      "\n  "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("i-progress", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isProgressActive && !_vm.isLoadingBarCustom,
                expression: "isProgressActive && !isLoadingBarCustom",
              },
            ],
            class: { "top-fixed": _vm.isAppReady },
            attrs: {
              value: _vm.progressValue,
              max: _vm.progressMax,
              color: _vm.color,
              color2: _vm.color2,
            },
          }),
          _vm._v(" "),
          _c("fullscreen-video", {
            staticClass: "video",
            attrs: {
              "is-fullscreen": _vm.isLoadingBarCustom && !_vm.isAppReady,
              url: _vm.videoUrl,
              controls: false,
              "bg-color": "#fff",
              "is-muted": true,
              "is-paused": false,
              loop: true,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }